export const queueStatsChannelsProviderRTTI = Symbol.for("QueueStatsChannelsProvider");
export const getQueueStatsChannelsRTTI = Symbol.for("getQueueStatsChannels");
export const queueStatsQueuesProviderRTTI = Symbol.for("QueueStatsQueuesProvider");
export const getQueueStatsQueuesRTTI = Symbol.for("getQueueStatsQueues");
